import useDictionary from '../hooks/useDictionary';

import '../css/facts.css';

export default function Facts() {

    const dictionary = useDictionary();

    return (
        <div className="facts">
            <div className="fact">
                <div className="num">
                    2007
                </div>
                <div className="name">
                    {dictionary.ESTABLISHED}
                </div>
            </div>

            <div className="fact">
                <div className="num">
                    20+
                </div>
                <div className="name">
                    {dictionary.EXPERIENCE}
                </div>
            </div>

            <div className="fact">
                <div className="num">
                    EU + USA
                </div>
                <div className="name">
                    {dictionary.RANGE}
                </div>
            </div>
            <div className="fact">
                <div className="num">
                    100%
                </div>
                <div className="name">
                    {dictionary.MADE_IN_POLAND}
                </div>
            </div>
            <div className="fact">
                <div className="num">
                    B2B
                </div>
                <div className="name">
                    {dictionary.B2B_PLATFORM}
                </div>
            </div>
            <div className="fact">
                <div className="num">
                    Negativ®
                </div>
                <div className="name">
                    {dictionary.TRADEMARK_RESTRICTED}
                </div>
            </div>

        </div>
    )
}